var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageChatCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-chat-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.09436 11.7288C6.03221 11.3282 5.99996 10.9179 5.99996 10.5C5.99996 6.08172 9.60525 2.5 14.0526 2.5C18.4999 2.5 22.1052 6.08172 22.1052 10.5C22.1052 11.4981 21.9213 12.4535 21.5852 13.3345C21.5154 13.5175 21.4804 13.609 21.4646 13.6804C21.4489 13.7512 21.4428 13.801 21.4411 13.8735C21.4394 13.9466 21.4493 14.0272 21.4692 14.1883L21.8717 17.4585C21.9153 17.8125 21.9371 17.9895 21.8782 18.1182C21.8266 18.231 21.735 18.3205 21.6211 18.3695C21.4911 18.4254 21.3146 18.3995 20.9617 18.3478L17.7765 17.8809C17.6101 17.8565 17.527 17.8443 17.4512 17.8448C17.3763 17.8452 17.3245 17.8507 17.2511 17.8661C17.177 17.8817 17.0823 17.9172 16.893 17.9881C16.0097 18.319 15.0524 18.5 14.0526 18.5C13.6344 18.5 13.2237 18.4683 12.8227 18.4073M7.63158 22.5C10.5965 22.5 13 20.0376 13 17C13 13.9624 10.5965 11.5 7.63158 11.5C4.66668 11.5 2.26316 13.9624 2.26316 17C2.26316 17.6106 2.36028 18.1979 2.53955 18.7467C2.61533 18.9787 2.65322 19.0947 2.66566 19.1739C2.67864 19.2567 2.68091 19.3031 2.67608 19.3867C2.67145 19.4668 2.65141 19.5573 2.61134 19.7383L2 22.5L4.9948 22.091C5.15827 22.0687 5.24 22.0575 5.31137 22.058C5.38652 22.0585 5.42641 22.0626 5.50011 22.0773C5.5701 22.0912 5.67416 22.1279 5.88227 22.2014C6.43059 22.3949 7.01911 22.5 7.63158 22.5Z",
    stroke: "#4F9CF9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageChatCircle);
export default __webpack_public_path__ + "static/media/message-chat-circle.bdfda82ccea303900c45ac9e8e99cdaf.svg";
export { ForwardRef as ReactComponent };